module.exports = __webpack_public_path__ + "static/img/160.b6fb5e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/160.png
// module id = emol
// module chunks = 0